import { jsx as _jsx } from "react/jsx-runtime";
var REACT_ELEMENT_TYPE;

function _jsx2(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import { Platform, TouchableNativeFeedback, TouchableOpacity, TouchableWithoutFeedback, View } from 'react-native';
let TouchableComponent;

if (Platform.OS === 'android') {
  TouchableComponent = Platform.Version <= 20 ? TouchableOpacity : TouchableNativeFeedback;
} else {
  TouchableComponent = TouchableOpacity;
}

if (TouchableComponent !== TouchableNativeFeedback) {
  TouchableComponent.SelectableBackground = () => ({});

  TouchableComponent.SelectableBackgroundBorderless = () => ({});

  TouchableComponent.Ripple = () => ({});

  TouchableComponent.canUseNativeForeground = () => false;
}

export default class PlatformTouchable extends React.Component {
  render() {
    let {
      children,
      style,
      foreground,
      background,
      useForeground,
      ...props
    } = this.props; // Even though it works for TouchableWithoutFeedback and
    // TouchableNativeFeedback with this component, we want
    // the API to be the same for all components so we require
    // exactly one direct child for every touchable type.

    children = React.Children.only(children);

    if (TouchableComponent === TouchableNativeFeedback) {
      useForeground = foreground && TouchableNativeFeedback.canUseNativeForeground();

      if (foreground && background) {
        console.warn('Specified foreground and background for Touchable, only one can be used at a time. Defaulted to foreground.');
      }

      return /*#__PURE__*/_jsx(TouchableComponent, { ...props,
        useForeground: useForeground,
        background: useForeground && foreground || background,
        children: /*#__PURE__*/_jsx2(View, {
          style: style
        }, void 0, children)
      });
    } else if (TouchableComponent === TouchableWithoutFeedback) {
      return /*#__PURE__*/_jsx(TouchableWithoutFeedback, { ...props,
        children: /*#__PURE__*/_jsx2(View, {
          style: style
        }, void 0, children)
      });
    } else {
      let TouchableFallback = this.props.fallback || TouchableComponent;
      return /*#__PURE__*/_jsx(TouchableFallback, { ...props,
        style: style,
        children: children
      });
    }
  }

}
PlatformTouchable.SelectableBackground = TouchableComponent.SelectableBackground;
PlatformTouchable.SelectableBackgroundBorderless = TouchableComponent.SelectableBackgroundBorderless;
PlatformTouchable.Ripple = TouchableComponent.Ripple;
PlatformTouchable.canUseNativeForeground = TouchableComponent.canUseNativeForeground;